import { memo } from 'react'
import { prosemirrorNodeToDom } from 'remirror'
import { Icon } from '@iconify/react'

import { Button } from '@pepper/ui'

import type { NodeViewComponentProps } from '@remirror/react'

import styles from './WrapperNodeView.module.css'

type Props = NodeViewComponentProps

function WrapperNodeView({
  node,
  view,
  forwardRef,
  getPosition,
}: Props): JSX.Element {
  const isEditable = view.editable

  const handleDeleteNode = () => {
    const position = (getPosition as () => number)()
    if (!position) {
      throw new Error('Cannot get position of the node')
    }
    const start = position
    const end = position + node.nodeSize
    view.dispatch(view.state.tr.delete(start, end))
  }

  const handleCopyNode = () => {
    const serializer = new XMLSerializer()
    const nodeString = serializer.serializeToString(prosemirrorNodeToDom(node))
    const clipboardItem = new ClipboardItem({
      'text/plain': new Blob([nodeString], { type: 'text/plain' }),
      'text/html': new Blob([nodeString], { type: 'text/html' }),
    })
    navigator.clipboard.write([clipboardItem])
  }

  return (
    <div className={styles.container}>
      <span ref={forwardRef} className={styles.contentContainer} />

      {isEditable && (
        <div className={styles.actionContainer} contentEditable={false}>
          <Button onClick={handleCopyNode} size="small" title="Copy Block">
            <Icon icon="uil:copy" />
          </Button>
          <Button onClick={handleDeleteNode} size="small" title="Delete Block">
            <Icon icon="fe:trash" />
          </Button>
        </div>
      )}
    </div>
  )
}

export default memo(WrapperNodeView)
